import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faArrowDown,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { PdfReader } from "../../utils/DocumentViewer";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class CommercialClauses extends React.Component {
  countError = "";
  state = {
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    leaseUploadDocumentDate: "",
    redirect: false,
    isOpen: false,
    pageNo: "",
    documentUrl: "",
    commercialClausesDetails: [],
    commercialClauses: [],
    uploadedDocuments: [],
    uploadedDocumentNames: [],
    currentDocument: "",
    popupContentType: "pdf",
    popupContentTypeDescription: "",
    initialValues: {
      commercialDetails: {
        clauseName: "",
        details: "",
        documentName: "",
        pageNo: "",
      },
    },
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  constructor(props) {
    super(props);

    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/commercial-clause/get-clauses`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          commercialClauses: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    let athis = this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-commercial-clauses-details?id=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      for (let i = 0; i < data.commercialClausesDetails.length; i++) {
        const index = athis.state.commercialClauses.findIndex(
          (x) => x.clause_name === data.commercialClausesDetails[i].clauseName
        );
        console.log(index);
        if (index > -1) {
          athis.state.commercialClauses.splice(index, 1);
        }
      }
      for (let i = 0; i < data.lease_documents.length; i++) {
        athis.state.uploadedDocumentNames.push(
          data.lease_documents[i].leaseDocumentType
        );
      }
      athis.setState({
        initialValues: data,
        commercialClausesDetails: data.commercialClausesDetails,
        renewalLeaseTermDD: data.renewalLeaseTermDD,
        renewalLeaseTermMM: data.renewalLeaseTermMM,
        renewalLeaseTermYY: data.renewalLeaseTermYY,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        notes_14: data.notes_14,
        documentUrl: data.url,
        pageNo: data.commercialClausesDetails.pageNo,
        leaseUploadDocumentDate: data.leaseUploadDocumentDate,
        uploadedDocuments: data.lease_documents,
      });
      var _intialValues = athis.state.initialValues;
      _intialValues.commercialDetails = {
        clauseName: "",
        details: "",
        documentName: "",
        pageNo: "",
      };

      athis.setState({
        initialValues: _intialValues,
      });
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-commercial-clauses-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     console.log(data);
    //     for (let i = 0; i < data.commercialClausesDetails.length; i++) {
    //       const index = this.state.commercialClauses.findIndex(
    //         (x) => x.clause_name === data.commercialClausesDetails[i].clauseName
    //       );
    //       console.log(index);
    //       if (index > -1) {
    //         this.state.commercialClauses.splice(index, 1);
    //       }
    //     }
    //     for (let i = 0; i < data.lease_documents.length; i++) {
    //       this.state.uploadedDocumentNames.push(
    //         data.lease_documents[i].leaseDocumentType
    //       );
    //     }
    //     this.setState({
    //       initialValues: data,
    //       commercialClausesDetails: data.commercialClausesDetails,
    //       renewalLeaseTermDD: data.renewalLeaseTermDD,
    //       renewalLeaseTermMM: data.renewalLeaseTermMM,
    //       renewalLeaseTermYY: data.renewalLeaseTermYY,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       notes_14: data.notes_14,
    //       documentUrl: data.url,
    //       pageNo: data.commercialClausesDetails.pageNo,
    //       leaseUploadDocumentDate: data.leaseUploadDocumentDate,
    //       uploadedDocuments: data.lease_documents,
    //     });
    //     var _intialValues = this.state.initialValues;
    //     _intialValues.commercialDetails = {
    //       clauseName: "",
    //       details: "",
    //       documentName: "",
    //       pageNo: "",
    //     };

    //     this.setState({
    //       initialValues: _intialValues,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }
  showDocumentDate(docType) {
    let obj = this.state.uploadedDocuments.find(
      (o) => o.leaseDocumentUrl === docType
    );
    if (obj !== undefined) {
      return leaseDateFormat(obj.leaseUploadDocumentDate);
    } else {
      return "";
    }
  }

  formatDate(date) {
    return leaseDateFormat(date);
  }


  addCommercialDetails = (values) => {
    //resetForm();
    if (!this.validator.allValid()) {
      console.log(this.validator);
      this.validator.showMessages();
      return false;
    }

    let docSelected = this.state.uploadedDocuments.find((obj) => obj.leaseDocumentUrl === values.commercialDetails.document )

    //console.log(docSelected, "doc selected..")  
    values.commercialDetails.document = docSelected.leaseDocumentType; 
    values.commercialDetails.documentUrl = docSelected.leaseDocumentUrl; 
    

    var _commercialClausesDetails = this.state.commercialClausesDetails;
    _commercialClausesDetails.push(values.commercialDetails);
    console.log(_commercialClausesDetails, "needed");
    this.setState({
      commercialClausesDetails: _commercialClausesDetails,
    });
    const index = this.state.commercialClauses.findIndex(
      (x) => x.clause_name === values.commercialDetails.clauseName
    );
    console.log(index);
    if (index > -1) {
      console.log("inn");
      this.state.commercialClauses.splice(index, 1);
    }
    this.setState({});

    return true;
  };

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match.path;
      let urlPath = url.split("/");
      this.state.redirect = false;
      return (
        <Redirect
          push
          //to={"/createlease/other-clauses/" + this.props.match.params.id}
          to={`/${urlPath[1]}/other-clauses/` + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Critical Clause</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Commercial Clauses</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                if (this.state.commercialClausesDetails.length == 0) {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                values.commercialClausesDetails =
                  this.state.commercialClausesDetails;
                console.log(values, "gg");
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-commercial-clauses-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,

                resetForm,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" >
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          <div className="newGridSectionInner">
                            <label>
                              Lease Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder"
                                    value={this.state.leaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder"
                                    value={this.state.leaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder"
                                    value={this.state.leaseTermDD}
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder"
                                    value={this.state.renewalLeaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder"
                                    value={this.state.renewalLeaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder"
                                    value={this.state.renewalLeaseTermDD}
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseRenewalTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              From
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="from" />
                              <ErrorMessage
                                name="from"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              To
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="to" />
                              <ErrorMessage
                                name="to"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Clause Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="commercialDetails.clauseName"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option
                                  value=""
                                  label="Select"
                                  defaultValue
                                />
                                {this.state.commercialClauses.map((obj) => (
                                  <option
                                    key={obj.id}
                                    value={obj.clause_name}
                                  >
                                    {obj.clause_name}
                                  </option>
                                ))}
                              </Field>
                              {this.validator.message(
                                "Clause Name",
                                values.commercialDetails.clauseName,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Details <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="textarea"
                                className="details"
                                name="commercialDetails.details"
                              />
                              {this.validator.message(
                                "Details",
                                values.commercialDetails.details,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Document Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="commercialDetails.document"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.uploadedDocuments.map((obj) => (
                                  <option key={obj.leaseDocumentType} value={obj.leaseDocumentUrl}>
                                    {obj.leaseDocumentType} ({this.formatDate(obj.leaseUploadDocumentDate)})
                                  </option>
                                ))}

                              </Field>
                              {this.validator.message(
                                "Document List",
                                values.commercialDetails.document,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Page No. <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type="text"
                                name="commercialDetails.pageNo"
                                onChange={(e) => {
                                  this.state.pageNo = e.target.value;
                                  handleChange(e);
                                }}
                              />
                              {this.validator.message(
                                "page No",
                                values.commercialDetails.pageNo,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_14" />
                          </div>

                        </div>
                        <div className="button_group mt-3 d-flex align-items-center gap-2 justify-content-end">
                          <button
                            className="add_button"
                            type="button"
                            onClick={(e) => {
                              if (this.addCommercialDetails(values)) {
                                resetForm();
                                this.validator.hideMessages();
                              }
                            }}
                          >
                            Add
                          </button>
                          <button
                            className="reset_button"
                            type="reset"
                            disabled={isSubmitting}
                          >
                            Reset
                          </button>
                        </div>
                        {this.mainFormValidator.message(
                          "Commercial Clauses",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Clause Name</th>
                                <th scope="col">Document Name</th>
                                <th scope="col">Document Date</th>
                                <th scope="col">Document Page Number</th>
                                <th scope="col">Information</th>
                                <th scope="col" colSpan="">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.commercialClausesDetails.map(function (
                                name,
                                index
                              ) {

                                return (
                                  <tr key={"cdocTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <a
                                        className="clauseNameLink"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.state.pageNo = name.pageNo;
                                          let obj =
                                            this.state.uploadedDocuments.find(
                                              (o) =>
                                              o.leaseDocumentType ===
                                              name.document && o.leaseDocumentUrl === name.documentUrl
                                            );
                                          this.state.currentDocument = obj.url;
                                          this.state.popupContentType = obj.uploadDocType;
                                          this.state.popupContentTypeDescription = name.details;
                                          //console.log(obj);
                                          this.openModal();
                                        }}
                                      >
                                        {name.clauseName}
                                      </a>
                                    </td>
                                    <td>{name.document}</td>
                                    <td>
                                      {this.showDocumentDate(name.documentUrl)}
                                    </td>
                                    <td>{name.pageNo}</td>
                                    <td>{name.pageNo}</td>
                                    <td>
                                      <button
                                        type="button"
                                        className="actionDelete rentalDeleteButton"
                                        onClick={(e) => {
                                          var _docs =
                                            this.state.commercialClausesDetails;
                                          _docs.splice(index, 1);
                                          console.log(_docs, "new array");
                                          this.setState({
                                            commercialClausesDetails: _docs,
                                          });
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTimes} />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              },
                                this)}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                        <div className="row m-0">
                          <div className="col-lg-12">
                            <Modal
                              show={this.state.isOpen}
                              onHide={this.closeModal}
                              size="lg"
                              className="documentModal"
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>
                                  <div className="container modalBreadCrumbs">
                                    <div className="row m-0">
                                      <div className="col-lg-12">
                                        <ul>
                                          <li>Document</li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="container">
                                  <div className="row m-0">
                                    {this.state.popupContentType == 'pdf' ? (
                                      <PdfReader
                                        url={this.state.currentDocument}
                                        pageNumber={this.state.pageNo}
                                      />
                                    ) : (
                                      <div>
                                        {this.state.popupContentTypeDescription}
                                      </div>
                                    )
                                    }
                                  </div>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </div>
    );
  }
}

export default withRouter(CommercialClauses);
